import { useState } from 'react';
import css from './Section.module.css';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';
import { PrimaryButton } from '../../../components';
import faqImage from '../assets/sectionHero1.jpeg';

const SectionFAQ = props => {
  const { intl, viewport } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const contactEmail = intl.formatMessage({ id: 'Footer.supportEmail' });
  const faqs = [
    {
      questionId: 'SectionFAQ.faq1.question',
      answerId: 'SectionFAQ.faq1.answer',
    },
    {
      questionId: 'SectionFAQ.faq2.question',
      answerId: 'SectionFAQ.faq2.answer',
    },
    {
      questionId: 'SectionFAQ.faq3.question',
      answerId: 'SectionFAQ.faq3.answer',
    },
    {
      questionId: 'SectionFAQ.faq4.question',
      answerId: 'SectionFAQ.faq4.answer',
    },
    {
      questionId: 'SectionFAQ.faq5.question',
      answerId: 'SectionFAQ.faq5.answer',
    },
    {
      questionId: 'SectionFAQ.faq6.question',
      answerId: 'SectionFAQ.faq6.answer',
    },
    {
      questionId: 'SectionFAQ.faq7.question',
      answerId: 'SectionFAQ.faq7.answer',
    },
    {
      questionId: 'SectionFAQ.faq8.question',
      answerId: 'SectionFAQ.faq8.answer',
    },
    {
      questionId: 'SectionFAQ.faq9.question',
      answerId: 'SectionFAQ.faq9.answer',
    },
    {
      questionId: 'SectionFAQ.faq10.question',
      answerId: 'SectionFAQ.faq10.answer',
    },
    {
      questionId: 'SectionFAQ.faq11.question',
      answer: () => (
        <div className={css.faqInfo}>
          <p>{intl.formatMessage({ id: 'SectionFAQ.faq11.intro' })}</p>
          <ol>
            <li>{intl.formatMessage({ id: 'SectionFAQ.faq11.option1' })}</li>
            <li>{intl.formatMessage({ id: 'SectionFAQ.faq11.option2' })}</li>
            <li>{intl.formatMessage({ id: 'SectionFAQ.faq11.option3' })}</li>
          </ol>
          <p>{intl.formatMessage({ id: 'SectionFAQ.faq11.note' })}</p>
        </div>
      ),
    },
  ];
  const half = Math.ceil(faqs.length / 2);
  const firstHalf = faqs.slice(0, half);
  const secondHalf = faqs.slice(half);

  const handleAccordionClick = index => {
    setActiveIndex(prev => (prev === index ? null : index)); // toggle
  };

  const handleContactClick = () => {
    window.location.href = `mailto:${contactEmail}`;
  };

  return (
    <div id="faq" className={css.faqContentWrapper}>
      <div className={css.fixedWidthContainer}>
        <div className={css.faqContent}>
          <div className={css.faqContentStart}>
            <div className={css.sectionHead}>
              <h2>{intl.formatMessage({ id: 'SectionFAQ.title' })}</h2>
            </div>
            <div className={css.scheduleSec}>
              <img src={faqImage} alt={intl.formatMessage({ id: 'SectionFAQ.imageAlt' })} />
              <h3>{intl.formatMessage({ id: 'SectionFAQ.stillHaveQuestions' })}</h3>
              <p>{intl.formatMessage({ id: 'SectionFAQ.cantFindAnswer' })}</p>
              <PrimaryButton onClick={handleContactClick}>
                {intl.formatMessage({ id: 'SectionFAQ.contactUs' })} <Icons name="rightAngle" />
              </PrimaryButton>
            </div>
          </div>
          <div className={css.faqSection}>
            <div className={css.faqBlock}>
              {firstHalf.map((faq, index) => (
                <div
                  key={index}
                  className={classNames(css.faqCard, {
                    [css.activeFAQ]: activeIndex === index,
                  })}
                  onClick={() => handleAccordionClick(index)}
                >
                  <div className={css.faqBody}>
                    <span className={css.faqHeading}>
                      {intl.formatMessage({ id: faq.questionId })}{' '}
                    </span>{' '}
                    {activeIndex === index && (
                      <div className={css.faqDescription}>
                        {faq.answerId ? intl.formatMessage({ id: faq.answerId }) : faq.answer()}
                      </div>
                    )}
                  </div>
                  <span className={css.faqIcon}>
                    {activeIndex === index ? (
                      <span>
                        <Icons name="faqOpenIcon" />
                      </span>
                    ) : (
                      <span>
                        <Icons name="faqCloseIcon" />
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
            <div className={css.faqBlock}>
              {secondHalf.map((faq, index) => {
                const realIndex = index + firstHalf.length;

                return (
                  <div
                    key={realIndex}
                    className={classNames(css.faqCard, {
                      [css.activeFAQ]: activeIndex === realIndex,
                    })}
                    onClick={() => handleAccordionClick(realIndex)}
                  >
                    <div className={css.faqBody}>
                      <span className={css.faqHeading}>
                        {intl.formatMessage({ id: faq.questionId })}
                      </span>
                      {activeIndex === realIndex && (
                        <div className={css.faqDescription}>
                          {faq.answerId ? intl.formatMessage({ id: faq.answerId }) : faq.answer()}
                        </div>
                      )}
                    </div>
                    <span className={css.faqIcon}>
                      {activeIndex === realIndex ? (
                        <span>
                          <Icons name="faqOpenIcon" />
                        </span>
                      ) : (
                        <span>
                          <Icons name="faqCloseIcon" />
                        </span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFAQ;
